import React from 'react';
import { CheckIcon } from '../lib/icons';
import { useReveal } from '../lib/useReveal';
const BENEFITS = ['Mayor equilibrio emocional', 'Claridad mental', 'Confianza para practicar', 'Capacidad de autosanación', 'Seguridad para ofrecer sesiones', 'Nueva herramienta profesional'];
export function BenefitsSection() {
  const [ref1, vis1] = useReveal();
  return <section id="benefits" className="bg-[#1e1e30] py-14 px-4 border-t border-white/5" data-id="element-40">
      <div className="container mx-auto max-w-3xl" data-id="element-41">
        <div ref={ref1} className={`reveal bg-[#252538] rounded-3xl p-6 md:p-10 shadow-lg border border-white/10 text-center ${vis1 ? 'is-visible' : ''}`} data-id="element-42">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mb-6" data-id="element-43">
            🌟 Lo que lograrás al completar el curso
          </h2>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-8 text-left max-w-lg mx-auto" data-id="element-44">
            {BENEFITS.map((item, idx) => <div key={idx} className="flex items-center gap-3 bg-[#1e1e30] p-4 rounded-xl border border-white/5" data-id="element-45">
                <div className="bg-[#d4a017]/20 p-1.5 rounded-full flex-shrink-0" data-id="element-46">
                  <CheckIcon className="w-5 h-5 text-[#f0c040]" strokeWidth={3} data-id="element-47" />
                </div>
                <span className="text-lg text-gray-200 font-medium" data-id="element-48">
                  {item}
                </span>
              </div>)}
          </div>

          <div className="inline-block px-8 py-3 bg-[#1e1e30] rounded-full text-[#f0c040] font-bold text-lg tracking-wide uppercase border border-[#d4a017]/20" data-id="element-49">
            Sanación + oportunidad real.
          </div>
        </div>
      </div>
    </section>;
}